<div class="modal-header header-bottom-border header-bottom-padding diamond-details-email">
  <h4 class="modal-title" id="standard-modalLabel">
    {{ title }}
  </h4>
  <i class="mdi mdi-close font-20 cursor-pointer float-end" (click)="activeModal.dismiss()"></i>
</div>
  <div class="modal-body py-0">
    <h5 class="my-0">{{content}}</h5>
  </div>
  <div class="modal-footer">
    @if (showContinueShoppingButton) {
      <button type="button" id="continue-shopping-button" class="btn btn-outline-info btn-rounded w-auto mt-0" (click)="activeModal.dismiss()">
        {{'Labels.ShoppingCart.ContinueShopping' | translate}}
      </button>
    }
    <button type="button" class="btn btn-info btn-rounded w-auto" (click)="onCheckOut()">
      {{ (showContinueShoppingButton ? 'Labels.ShoppingCart.GoToCart' : 'Labels.ShoppingCart.ManageCart') | translate }}
    </button>
  </div>
